import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/alto-custo-gerenciamento-processo`

    return {
        index(pacienteId) {

            return repository.get(`${baseUrl}/${pacienteId}`)
        },
        create(pacienteId) {

            return repository.get(`${baseUrl}/create/${pacienteId}`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}